module.exports = __webpack_public_path__ + "static/media/lock-opened.3d85d41e.svg";